import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared/state';

interface UseFiscalPeriodModalAnalyticIds {
  fiscalPeriodModalCancelBtnId: string;
  fiscalPeriodModalSelectBtnId: string;
  fiscalPeriodModalYearSelect: string;
  fiscalPeriodModalPeriodSelect: string;
  fiscalPeriodModalBackToProductSelection: string;
}

export const useFiscalPeriodModalAnalyticIds = (): UseFiscalPeriodModalAnalyticIds => {
  const fiscalPeriodModalCancelBtnId = useAnalyticId(AnalyticIdentifier.FISCAL_PERIOD_MODAL_CANCEL_BUTTON);
  const fiscalPeriodModalSelectBtnId = useAnalyticId(AnalyticIdentifier.FISCAL_PERIOD_MODAL_SELECT_BUTTON);
  const fiscalPeriodModalYearSelect = useAnalyticId(AnalyticIdentifier.FISCAL_PERIOD_MODAL_YEAR_SELECT);
  const fiscalPeriodModalPeriodSelect = useAnalyticId(AnalyticIdentifier.FISCAL_PERIOD_MODAL_PERIOD_SELECT);
  const fiscalPeriodModalBackToProductSelection = useAnalyticId(
    AnalyticIdentifier.FISCAL_PERIOD_MODAL_BACK_TO_PRODUCT_SELECTION,
  );

  return {
    fiscalPeriodModalCancelBtnId,
    fiscalPeriodModalSelectBtnId,
    fiscalPeriodModalYearSelect,
    fiscalPeriodModalPeriodSelect,
    fiscalPeriodModalBackToProductSelection,
  };
};
